// Health Coins + streaks client.
import { API_BASE } from './chat'

export type Achievement = { id: string; label: string; emoji: string }
export type GamifyState = {
  coins: number
  lifetime: number
  streak: number
  longest: number
  level: { name: string; next: { name: string; at: number } | null }
  achievements: Achievement[]
  ledger: { delta: number; reason: string; at: string }[]
}
export type CheckinResult = { state: GamifyState; awarded_coins: number; new_achievements: Achievement[] }
export type EarnRule = { kind: string; coins: number; label: string; description: string }

export async function getGamify(userId: string): Promise<GamifyState | null> {
  try {
    const r = await fetch(`${API_BASE}/v1/gamify/state?user_id=${encodeURIComponent(userId)}`)
    return r.ok ? await r.json() : null
  } catch {
    return null
  }
}

// Records a daily check-in (streak + coins, capped once/day server-side) and returns what changed.
export async function checkinGamify(userId: string): Promise<CheckinResult | null> {
  try {
    const r = await fetch(`${API_BASE}/v1/gamify/checkin?user_id=${encodeURIComponent(userId)}`, { method: 'POST' })
    return r.ok ? await r.json() : null
  } catch {
    return null
  }
}

// Every way to earn Health Coins, and how much — the "how do I earn coins" explainer.
export async function getEarnCatalog(): Promise<EarnRule[]> {
  try {
    const r = await fetch(`${API_BASE}/v1/gamify/earn-catalog`)
    return r.ok ? (await r.json()).catalog : []
  } catch {
    return []
  }
}
